import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ItemType } from '../types';
import PageButton from './PageButton';
import StepButton from './StepButton';
import PageSeparator from './PageSeparator';
import StyledItem from './PaginationItem.styles';

var PaginationItem = function PaginationItem(props) {
  var type = props.type;

  var renderItemContent = function renderItemContent() {
    switch (type) {
      case ItemType.PageNumber:
        return /*#__PURE__*/React.createElement(PageButton, props);

      case ItemType.PrevPage:
        return /*#__PURE__*/React.createElement(StepButton, _extends({}, props, {
          "aria-label": "Go to previous page"
        }));

      case ItemType.NextPage:
        return /*#__PURE__*/React.createElement(StepButton, _extends({}, props, {
          "aria-label": "Go to next page"
        }));

      default:
        return /*#__PURE__*/React.createElement(PageSeparator, null);
    }
  };

  return /*#__PURE__*/React.createElement(StyledItem, null, renderItemContent());
};

export default PaginationItem;